module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/deluxe_desktop-47f555db38f288cf540ac23d08deb7bc.webp";